import React from 'react';
import { func, number, object, shape } from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';
import { BQ_CLICKED_REVIEWS_RATINGS } from '../../../utils/bigQueryEvents';
import { validateOverview } from '../../../utils/mainComponentsValidator';
import { REVIEWS } from '../../../utils/pageSections';
import RatingWrapper from '../RatingWrapper';

import classes from './index.module.scss';

const UserInfo = ({
    overview
}, { biEvents, scrollToSection }) => {
    const onReviewsClick = () => {
        biEvents.sendBigQueryEvent({ eventName: BQ_CLICKED_REVIEWS_RATINGS });
        scrollToSection({ sectionKey: REVIEWS });
    };

    if (!validateOverview({ overview })) {
        return null;
    }

    const { gig } = overview;
    const { ordersInQueue, ratingsCount, rating } = gig;
    const hasOrdersInQueue = ordersInQueue > 0;
    const hasRating = ratingsCount > 0 && !!rating;

    return (
        <div className={classes.userInfo}>
            { hasRating &&
                <RatingWrapper className={classes.userInfoRating}
                    onClick={onReviewsClick}
                    rating={rating}
                    ratingsCount={ratingsCount}/>
            }
            { hasOrdersInQueue &&
                <span className={classes.ordersInQueue}>
                    <I18n k="gig_page_perseus.overview.orders_in_queue_single_plural" params={{ count: ordersInQueue }}/>
                </span>
            }
        </div>
    );
};

UserInfo.propTypes = {
    overview: shape({
        gig: shape({
            rating: number,
            ratingsCount: number,
            ordersInQueue: number
        })
    })
};

UserInfo.contextTypes = {
    biEvents: object,
    scrollToSection: func
};

export default UserInfo;
